export const SEARCH_PARAMS_INTERNAL = 'connection';
export const SEARCH_PARAMS_ENCRYPTED = 'param';
export const SESSION_STORAGE_ENCRYPTED_PARAM = 'cdus.encryptedLaunchParam';
